import { call, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import { isEmpty } from 'lodash'

import {
  GET_SUBSCRIPTION,
  GET_SUBSCRIPTION_START,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_ERROR,
  GET_SUBSCRIPTION_FINALLY,
  SET_SUBSCRIPTIONS,
  SET_SUBSCRIPTIONS_START,
  SET_SUBSCRIPTIONS_SUCCESS,
  SET_SUBSCRIPTIONS_ERROR,
  CHANGE_SUBSCRIPTION,
  CHANGE_SUBSCRIPTION_START,
  CHANGE_SUBSCRIPTION_SUCCESS,
  CHANGE_SUBSCRIPTION_ERROR,
  VALIDATE_SUBSCRIPTION,
  VALIDATE_SUBSCRIPTION_START,
  VALIDATE_SUBSCRIPTION_SUCCESS,
  VALIDATE_SUBSCRIPTION_ERROR,
  VALIDATE_SUBSCRIPTION_FINALLY,
  CANCEL_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION_START,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CANCEL_SUBSCRIPTION_ERROR,
  CANCEL_SUBSCRIPTION_FINALLY,
  SET_COMPENSATION,
  SET_COMPENSATION_START,
  SET_COMPENSATION_ERROR,
  SET_COMPENSATION_FINALLY,
  AUTH_KEYCLOAK_ERROR
} from '../../redux/actions'

import { getKeycloakUserInfo } from '../../utils/tokenStorage'
import { refreshTokenOttWeb } from '../../utils/refreshtoken';

function* GetSubscriptionAction({ payload: { keycloak, appendRefound = false } }) {
  yield put(GET_SUBSCRIPTION_START())

  let token;
  try {
    token = (yield call(refreshTokenOttWeb, keycloak)).token
  } catch (err) {
    yield put(AUTH_KEYCLOAK_ERROR({ error: err.message }))
    yield put(GET_SUBSCRIPTION_FINALLY())
    return
  }
  try {
    let subscription = {}
    let isFreePlan = true
    let subscriptionsPlanIds = []
    const userInfoFromStorage = getKeycloakUserInfo()

    const headers = {
      headers: { 'authorization': `Bearer ${token}` },
      timeout: 10000
    }

    let { status, data: subscriber } = yield call(axios.get,
      `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${userInfoFromStorage.sub}`,
      headers
    )

    if (status === 204) {
      const newSubs = {
        uid: userInfoFromStorage.sub,
        personal_id: '11111111-1',
        email: userInfoFromStorage.email,
        name: userInfoFromStorage.name,
        username: userInfoFromStorage.name,
        first_name: userInfoFromStorage.first_name || 'N',
        last_name: userInfoFromStorage.last_name || 'N',
        country_code: '56',
      }

      const { status: createdStatus, data: createdSubscriber } = yield call(axios.post,
        `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers`,
        newSubs,
        headers
      )

      if (createdStatus === 201) {
        subscriber = createdSubscriber
      }
    }

    const { data } = yield call(axios.get,
      `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${userInfoFromStorage.sub}/subscriptions?active=true&appendRefound=${appendRefound}`,
      headers
    )
    subscriptionsPlanIds = data.map(x => x.plan_id)

    // MGO-E84-H1: mapa plan_id → hasAds de TODOS los planes activos (sin filtrar por tipo).
    // Alimenta la decisión de preroll por-contenido (shouldShowAds). true = con ads;
    // solo el booleano false apaga ads (Plan.hasAds !== false). Inmune al enmascarado unique_pay.
    const planIdToHasAds = data
      .filter(sub => sub.active)
      .reduce((acc, sub) => {
        acc[sub.plan_id] = sub.Plan?.hasAds !== false
        return acc
      }, {})

    // MGO-E85: excluir compras one-time (unique_pay) de la suscripción recurrente.
    const activeAndPaidSubscription = data.filter(sub => (
      sub.active && sub.plan_id !== process.env.REACT_APP_MS_PLAN_BASICO && sub.Plan.type === 'SUBSCRIPTION' && sub.Plan?.unique_pay !== true
    ))

    // MGO-E85: "Contenido comprado" = planes con unique_pay === true.
    const oneTimePurchases = data.filter(sub => sub.active && sub.Plan?.unique_pay === true)

    if (isEmpty(activeAndPaidSubscription)) {
      const activeAndBasicSubscription = data.filter(sub => (
        sub.active && sub.plan_id === process.env.REACT_APP_MS_PLAN_BASICO
      ))
      subscription = activeAndBasicSubscription[0]
    } else {
      subscription = activeAndPaidSubscription[0]
    }

    if (isEmpty(subscription) || isEmpty(activeAndPaidSubscription)) {
      isFreePlan = true
    } else {
      isFreePlan = false
    }

    let subscriberAux = subscriber
    if (!isEmpty(subscriber?.idp_id)) {
      try {
        const { data: idp } = yield call(axios.get,
          `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}idp/${subscriber.idp_id}`,
          headers
        )

        !isEmpty(idp) && (
          subscriberAux = {
            ...subscriber,
            idp
          }
        )
      } catch { }
    }

    yield put(GET_SUBSCRIPTION_SUCCESS({ subscription, isFreePlan, subscriptionsPlanIds, subscriber: subscriberAux, oneTimePurchases, planIdToHasAds }))
  } catch (error) {
    yield put(GET_SUBSCRIPTION_ERROR(error?.message || error ))
  } finally {
    yield put(GET_SUBSCRIPTION_FINALLY())
  }
}

function* SetSubscriptionAction({ payload: { keycloak, planId, isSubscription, distributor_id } }) {
  yield put(SET_SUBSCRIPTIONS_START())

  const sub = keycloak ? keycloak.subject : null

  let token;
  try {
    token = (yield call(refreshTokenOttWeb, keycloak)).token
  } catch (err) {
    yield put(AUTH_KEYCLOAK_ERROR({ error: err.message }))
    return
  }

  try {

    const headers = {
      headers: { 'authorization': `Bearer ${token}` },
      timeout: 10000
    }

    const url = isSubscription
      ? `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${sub}/subscriptions`
      : `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${sub}/one-time/`

    const { data: { url_to_pay_subscription: urlToPaySubscription } } = yield call(axios.post,
      url,
      {
        plan_id: planId,
        url_callback: process.env.REACT_APP_SUBSCRIPTIONS_API_URL_CALLBACK,
        distributor_id: distributor_id,
      },
      headers
    )

    !isEmpty(urlToPaySubscription) && window.location.replace(urlToPaySubscription)
    yield put(SET_SUBSCRIPTIONS_SUCCESS(urlToPaySubscription))
  } catch (error) {
    yield put(SET_SUBSCRIPTIONS_ERROR(error.message))
  }
}

function* ChangeSubscriptionAction({ payload: { keycloak, planId, subscriptionId } }) {
  yield put(CHANGE_SUBSCRIPTION_START())

  const sub = keycloak ? keycloak.subject : null

  let token;
  try {
    token = (yield call(refreshTokenOttWeb, keycloak)).token
  } catch (err) {
    yield put(AUTH_KEYCLOAK_ERROR({ error: err.message }))
    return
  }
  try {

    const headers = {
      headers: { 'authorization': `Bearer ${token}` },
      timeout: 10000
    }

    const { data: { url_to_pay_subscription: urlToPaySubscription } } = yield call(axios.post,
      `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${sub}/subscriptions/${subscriptionId}/change-plan`,
      {
        plan_id: planId,
        url_callback: process.env.REACT_APP_SUBSCRIPTIONS_API_URL_CALLBACK
      },
      headers
    )

    !isEmpty(urlToPaySubscription) && window.location.replace(urlToPaySubscription)
    yield put(CHANGE_SUBSCRIPTION_SUCCESS(urlToPaySubscription))
  } catch (error) {
    yield put(CHANGE_SUBSCRIPTION_ERROR(error.message))
  }
}

function* ValidateSubscriptionAction({ payload: { keycloak, transactionId } }) {
  yield put(VALIDATE_SUBSCRIPTION_START())

  let token;
  try {
    token = (yield call(refreshTokenOttWeb, keycloak)).token
  } catch (err) {
    yield put(AUTH_KEYCLOAK_ERROR({ error: err.message }))
    yield put(VALIDATE_SUBSCRIPTION_FINALLY())
    return
  }
  try {

    const headers = {
      headers: { 'authorization': `Bearer ${token}` },
      timeout: 10000
    }

    const { data } = yield call(axios.get,
      `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}transactions/${transactionId}`,
      headers
    )

    yield put(VALIDATE_SUBSCRIPTION_SUCCESS(data))
  } catch (error) {
    yield put(VALIDATE_SUBSCRIPTION_ERROR(error.message))
  } finally {
    yield put(VALIDATE_SUBSCRIPTION_FINALLY())
  }
}

function* CancelSubscriptionAction({ payload: { keycloak, subscription_id, subscriptor_id, url_callback } }) {
  yield put(CANCEL_SUBSCRIPTION_START())

  let token;
  try {
    token = (yield call(refreshTokenOttWeb, keycloak)).token
  } catch (err) {
    yield put(AUTH_KEYCLOAK_ERROR({ error: err.message }))
    yield put(CANCEL_SUBSCRIPTION_FINALLY())
    return
  }
  try {

    const headers = {
      headers: { 'authorization': `Bearer ${token}` },
      timeout: 10000
    }

    const { data } = yield call(axios.put,
      `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${subscriptor_id}/subscriptions/${subscription_id}/cancel`,
      {
        url_callback: url_callback
      },
      headers
    )

    !isEmpty(data.cancelUrl)
      ? window.location.replace(data.cancelUrl)
      : yield put(CANCEL_SUBSCRIPTION_SUCCESS(data))
  } catch (error) {
    yield put(CANCEL_SUBSCRIPTION_ERROR(error.message))
  } finally {
    yield put(CANCEL_SUBSCRIPTION_FINALLY())
  }
}

function* SetCompensationAction({ payload: { keycloak, clientRequest, subscriber_id, transaction_id } }) {
  yield put(SET_COMPENSATION_START())

  let token;
  try {
    token = (yield call(refreshTokenOttWeb, keycloak)).token
  } catch (err) {
    yield put(AUTH_KEYCLOAK_ERROR({ error: err.message }))
    yield put(SET_COMPENSATION_FINALLY())
    return
  }
  try {

    const headers = {
      headers: { 'authorization': `Bearer ${token}` },
      timeout: 10000
    }

    let path
    if (clientRequest === 'COUPON_COMPENSATION') {
      path = `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${subscriber_id}/transactions/${transaction_id}/cupon-compensation-confirmation`
    }
    if (clientRequest === 'REFOUND_COMPENSATION') {
      path = `${process.env.REACT_APP_SUBSCRIPTIONS_API_URL}subscribers/${subscriber_id}/transactions/${transaction_id}/refound-compensation-confirmation`
    }

    yield call(axios.put, path, null, headers)
  } catch (error) {
    yield put(SET_COMPENSATION_ERROR(error.message))
  } finally {
    yield put(SET_COMPENSATION_FINALLY())
  }
}

export default function* actionsWatcher() {
  yield takeLatest(GET_SUBSCRIPTION, GetSubscriptionAction)
  yield takeLatest(SET_SUBSCRIPTIONS, SetSubscriptionAction)
  yield takeLatest(CHANGE_SUBSCRIPTION, ChangeSubscriptionAction)
  yield takeLatest(VALIDATE_SUBSCRIPTION, ValidateSubscriptionAction)
  yield takeLatest(CANCEL_SUBSCRIPTION, CancelSubscriptionAction)
  yield takeLatest(SET_COMPENSATION, SetCompensationAction)
}